/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@shared/apis/fetch-clients/radar-fetch-client";
import type { GetConsumptionQueryResponse, GetConsumptionHeaderParams } from "../../models/contactsController/GetConsumption";
import type { Client, RequestConfig, ResponseErrorConfig } from "@shared/apis/fetch-clients/radar-fetch-client";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getConsumptionQueryKey = () => [{ url: '/contacts/consumption' }] as const

export type GetConsumptionQueryKey = ReturnType<typeof getConsumptionQueryKey>

/**
 * @summary Get the authenticated user's contacts consumption and compare with limits
 * {@link /contacts/consumption}
 */
export async function getConsumption(headers?: GetConsumptionHeaderParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetConsumptionQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : `/contacts/consumption`, ... requestConfig, headers : { ...headers, ...requestConfig.headers } })
  return res.data
}

export function getConsumptionQueryOptions(headers?: GetConsumptionHeaderParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getConsumptionQueryKey()
        return queryOptions<GetConsumptionQueryResponse, ResponseErrorConfig<Error>, GetConsumptionQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return getConsumption(headers, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get the authenticated user's contacts consumption and compare with limits
 * {@link /contacts/consumption}
 */
export function useGetConsumption<TData = GetConsumptionQueryResponse, TQueryData = GetConsumptionQueryResponse, TQueryKey extends QueryKey = GetConsumptionQueryKey>(headers?: GetConsumptionHeaderParams, options: 
{
  query?: Partial<QueryObserverOptions<GetConsumptionQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getConsumptionQueryKey()
         

         const query = useQuery({
          ...getConsumptionQueryOptions(headers, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}